import type { PermissionsState } from '@awork/features/workspace/state/permissions.store'
import { PermissionsStore } from '@awork/features/workspace/state/permissions.store'
import type { Signal } from '@angular/core'
import { computed, Injectable, inject } from '@angular/core'
import { UserPermissions } from '@awork/features/workspace/models/permissions.model'
import { SignalQuery } from '@awork/core/state/signal-store/signalQuery'
import { Role } from '@awork/features/workspace/models/role.model'

@Injectable({ providedIn: 'root' })
export class PermissionsQuery extends SignalQuery<PermissionsState> {
  protected store: PermissionsStore

  constructor() {
    const store = inject(PermissionsStore)

    super(store)

    this.store = store
  }

  /**
   * Gets the User permissions
   * @returns {UserPermissions}
   */
  getUserPermissions(): UserPermissions {
    const state = this.getValue()
    return state ? new UserPermissions(state) : null
  }

  /**
   * Gets the User permissions
   * @returns {Signal<UserPermissions>}
   */
  queryUserPermissions(): Signal<UserPermissions> {
    return computed(() => {
      const permissions = this.query()
      return new UserPermissions(permissions())
    })
  }

  /**
   * Gets the Workspace roles
   * @returns {Signal<Role[]>}
   */
  queryRoles(): Signal<Role[]> {
    return computed(() => {
      const roles = this.query('roles')
      return roles().map(role => new Role(role))
    })
  }
}
